import Vue from 'vue'
import VueRouter from 'vue-router'
import mine from './mine';
import apply from './apply';
import stats from './stats';
import Login from '@/views/Login';

// 捕获vue-router的push导致的异常
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => err)
};

Vue.use(VueRouter);

const routes = [
    ...apply,
    ...stats,
    ...mine,
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        name: '登录',
        component: Login
    },
    {
        path: '*',
        redirect: '/',
    },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
